import React from "react";
import { createPortal } from "react-dom";

import Backdrop from "./Backdrop";

interface ModalProps {
  children?: React.ReactNode;
  onClose: () => void;
}

// create a modal element to be used as a portal
const Modal: React.FC<ModalProps> = ({ children, onClose }) => {
  return createPortal(
    <>
      <Backdrop onClose={onClose} />
      {children}
    </>,
    document.getElementById("modal") as HTMLElement
  );
};

export default Modal;
